export default __webpack_public_path__ + "static/media/fsw_7.208e5ac5.png";